import React, { useEffect, useState } from "react";
import { Input } from "./ui/input";

// Input numérico que muestra la casilla vacía (con placeholder "0") cuando el valor es 0,
// permite borrarla sin quedar atrapado en "0", y mantiene el estado como número para no
// romper cálculos ni el guardado.
export const NumberInput = ({ value, onValueChange, placeholder, ...props }) => {
  const [local, setLocal] = useState(value ? String(value) : "");

  useEffect(() => {
    const n = local === "" ? 0 : Number(local);
    if (n !== Number(value || 0)) setLocal(value ? String(value) : "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handle = (e) => {
    const v = e.target.value;
    setLocal(v);
    onValueChange(v === "" ? 0 : Number(v));
  };

  return <Input type="number" inputMode="decimal" value={local} onChange={handle} placeholder={placeholder ?? "0"} {...props} />;
};
